var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "rowitems" }, [
    _c("div", { staticClass: "o-itemsBar", class: { open: _vm.menuOpen } }, [
      _c("div", { staticClass: "m-itemsBar__title" }, [
        _c("p", [_vm._v(_vm._s(_vm.menuOpenNazov))]),
        _vm._v(" "),
        _c("button", {
          staticClass: "a-itemsBar_close",
          on: {
            click: function($event) {
              return _vm.$emit("hideInventar")
            }
          }
        })
      ]),
      _vm._v(" "),
      _vm.kravicka.repozitar_kravicky
        ? _c(
            "div",
            { staticClass: "container" },
            [
              _vm.checkEmptyProducts || _vm.isMinihry
                ? [
                    _c(
                      "carousel",
                      {
                        staticClass: "m-itemBar__carousel",
                        attrs: {
                          perPageCustom: [[768, 5], [1024, 6], [1200, 9]],
                          navigationEnabled: true,
                          "navigation-next-label": "",
                          "navigation-prev-label": ""
                        }
                      },
                      [
                        !_vm.isMinihry
                          ? [
                              _vm._l(
                                _vm.kravicka.repozitar_kravicky.filter(
                                  _vm.checkCategory
                                ),
                                function(item) {
                                  return [
                                    item.repozitar_kravicky_usage_type > 0
                                      ? _c(
                                          "slide",
                                          {
                                            on: {
                                              slideclick: function($event) {
                                                _vm.$emit(
                                                  "useInventarProdukt",
                                                  _vm.kravicka.repozitar_kravicky.indexOf(
                                                    item
                                                  ),
                                                  item
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "a-itemBar__body",
                                                class: {
                                                  "--empty":
                                                    item.repozitar_kravicky_usage_type ==
                                                    0
                                                }
                                              },
                                              [
                                                _c("img", {
                                                  staticClass: "img-fluid",
                                                  attrs: {
                                                    src:
                                                      "assets/img/produkty/" +
                                                      item.repozitar_kravicky_category +
                                                      "/" +
                                                      item.herny_produkt_id
                                                        .herny_produkt_img_inventar,
                                                    alt: ""
                                                  }
                                                }),
                                                _vm._v(" "),
                                                item.herny_produkt_id
                                                  .herny_produkt_povoleny ==
                                                "preloader.png"
                                                  ? _c("img", {
                                                      staticClass:
                                                        "img-fluid item-preloader",
                                                      attrs: {
                                                        src:
                                                          "assets/img/produkty/preloader.png",
                                                        alt: ""
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.herny_produkt_id
                                                        .herny_produkt_meno
                                                    )
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                item.repozitar_kravicky_usage_type <
                                                999
                                                  ? _c(
                                                      "span",
                                                      { staticClass: "count" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.repozitar_kravicky_usage_type
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  : _c(
                                                      "span",
                                                      { staticClass: "count" },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              "font-size":
                                                                "24px"
                                                            }
                                                          },
                                                          [_vm._v("∞")]
                                                        )
                                                      ]
                                                    )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              )
                            ]
                          : [
                              _c(
                                "slide",
                                {
                                  on: {
                                    slideclick: function($event) {
                                      return _vm.$router.push({
                                        name: "pexeso-landing",
                                        params: {
                                          kravicka_id:
                                            _vm.$route.params.kravicka_id
                                        }
                                      })
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "a-itemBar__body" },
                                    [
                                      _c("img", {
                                        staticClass: "img-fluid",
                                        attrs: {
                                          src: "assets/img/pexeso/pexeso.svg",
                                          alt: ""
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("p", [_vm._v("Pexeso")])
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "slide",
                                {
                                  on: {
                                    slideclick: function($event) {
                                      return _vm.$router.push({
                                        name: "slider-landing",
                                        params: {
                                          kravicka_id:
                                            _vm.$route.params.kravicka_id
                                        }
                                      })
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "a-itemBar__body" },
                                    [
                                      _c("img", {
                                        staticClass: "img-fluid",
                                        attrs: {
                                          src: "assets/img/puzzle/puzzle.svg",
                                          alt: ""
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("p", [_vm._v("Skladanie obrázka")])
                                    ]
                                  )
                                ]
                              )
                            ]
                      ],
                      2
                    )
                  ]
                : [
                    _c(
                      "div",
                      {
                        staticClass:
                          "row align-items-center justify-content-center"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "col-md-6 text-center pt-4" },
                          [
                            _c("p", { staticClass: "colorWhite" }, [
                              _vm._v(
                                "Momentálne tu nemáš žiadnu vecičku pre kravičku. Kúp jej niečo v obchode."
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                staticClass: "btn --primary",
                                on: {
                                  click: function($event) {
                                    return _vm.$router.push({
                                      name: "obchod",
                                      params: {
                                        kategoria: _vm.menuOpenKategoria,
                                        kravicka_id: _vm.kravicka.id
                                      }
                                    })
                                  }
                                }
                              },
                              [_vm._v("Do obchodu")]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ]
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "m-carouselNav" })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }